export default (token = ':token') => `/${token}`;
